const a=".gator-card-content{padding:var(--spacing-6);font-size:.9375rem;color:var(--color-neutral-70)}";export{a as default};
